module.exports = __webpack_public_path__ + "media/hind/Hind-SemiBold-1bbd36a1.woff";